import { IDocumentAssemblerTemplate } from '@commenda/api';
import { Badge } from '@commenda/kakashi';

interface DocumentAssemblerTemplateDetailsCardProps {
  template: IDocumentAssemblerTemplate;
}

interface DetailProps {
  label: string;
  children: React.ReactNode;
}

const Detail = ({ label, children }: DetailProps) => (
  <div className="flex flex-col gap-xxs">
    <span className="txt-extra-small-medium text-text-tertiary">{label}</span>
    <div className="txt-small-regular text-text-primary">{children}</div>
  </div>
);

export const DocumentAssemblerTemplateDetailsCard = ({
  template,
}: DocumentAssemblerTemplateDetailsCardProps) => (
  <div className="flex flex-col gap-lg rounded-xl border border-border-primary p-xl">
    <div className="grid gap-lg md:grid-cols-2">
      <Detail label="Key">
        <span className="font-mono">{template.key}</span>
      </Detail>
      <Detail label="Categories">
        <div className="flex flex-wrap items-center gap-xs">
          {template.categories.map((category) => (
            <Badge
              key={category.id}
              variant={category.archivedAt ? 'warning' : 'gray'}
              size="sm"
            >
              {category.name}
              {category.archivedAt ? ' — archived' : ''}
            </Badge>
          ))}
        </div>
      </Detail>
      <Detail label="Active version">
        {template.activeVersion ? `v${template.activeVersion.version}` : 'None'}
      </Detail>
      <Detail label="Versions">{template.versionCount}</Detail>
    </div>
    <Detail label="What it covers">
      <p className="whitespace-pre-wrap text-text-secondary">
        {template.description}
      </p>
    </Detail>
  </div>
);
